var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { List, Stack, Typography } from '@mui/material';
import ExternalLink from './ExternalLink';
import InternalLink from './InternalLink';
import { ROLE } from '@/utils/constants';
import _ from 'lodash';
import { userInfoSelectUserInfo } from '@/store/auth/selectors';
import { useSelector } from 'react-redux';
var DrawerContent = function (_a) {
    var menu = _a.menu, open = _a.open, itemSelected = _a.itemSelected;
    var userInfo = useSelector(userInfoSelectUserInfo);
    var renderMenuOtherBaseOnRole = function (menus) {
        var _a, _b;
        if (!((_a = menus === null || menus === void 0 ? void 0 : menus[0].path) === null || _a === void 0 ? void 0 : _a.includes('/')))
            return menus;
        var rs = __spreadArray([], menus, true);
        if (((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.setting) === null || _b === void 0 ? void 0 : _b.role) !== ROLE.SUPER_ADMIN) {
            rs = rs.filter(function (x) {
                var screen = x.id.toUpperCase();
                if (screen === 'KNOWLEDGE_BASE' &&
                    !_.every([
                    // ROLE_FUNCTIONS.KNOWLEDGE_VIEW_KNOWLEDGE_BASE,
                    // ROLE_FUNCTIONS.KNOWLEDGE_VIEW_SUB_FOLDER,
                    ], function (func) { var _a; return (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.functions) === null || _a === void 0 ? void 0 : _a.includes(func); })) {
                    return false;
                }
                return true;
            });
        }
        return rs;
    };
    return (_jsx(Stack, { sx: { padding: '8px 20px 8px 20px' }, children: menu.map(function (g) { return (_jsx(List, { style: !open
                ? {
                    display: 'flex',
                    justifyContent: 'center',
                }
                : {}, subheader: open && g.label ? (_jsx(Typography, { display: "inline-block", variant: "caption", textTransform: "uppercase", sx: {
                    color: 'text.main',
                    fontWeight: 700,
                }, marginBottom: 2, children: g.label })) : (_jsx(_Fragment, {})), children: _jsx(Stack, { spacing: 1.2, children: renderMenuOtherBaseOnRole(g.items).map(function (menu) {
                    return menu.openInNew ? (_jsx(ExternalLink, { menu: menu, open: open }, "group_".concat(g.label, "_menu_").concat(menu.id))) : (_jsx(InternalLink, { menu: menu, open: open, itemSelected: itemSelected }, "group_".concat(g.label, "_menu_").concat(menu.id)));
                }) }) }, "group_".concat(g.label))); }) }));
};
export default DrawerContent;
